// import $ from 'jquery';
import React from 'react';
import ReactLoading from 'react-loading';
import Field from 'components/fields/Field';
import GooglePlacesAutocomplete, { geocodeByAddress } from 'react-google-places-autocomplete';
// import PropTypes from 'prop-types';

class FieldAddress extends Field {
    constructor(props) {
        super(props);

        this.componentForm = {
            subpremise: 'short_name',
            street_number: 'short_name',
            route: 'long_name',
            locality: 'long_name',
            administrative_area_level_1: 'short_name',
            postal_code: 'short_name',
            country: 'long_name',
        };
    }

    handleClasses() {
        return super.handleClasses().concat(' field--filled');
    }

    getAutocompletionRequest() {
        const { autocompletionRequest } = this.props;

        return {
            types: ['address'],
            componentRestrictions: {
                country: 'au',
            },
            ...autocompletionRequest
        };
    }

    /**
     * Process the given Address Data
     *
     * @param place
     * @return newData
     */
    processAddressData = (place) => {
        let fetched_address = {},
            newData = {};

        let componentForm = this.componentForm;

        let combined_address = '',
            // street_name = '',
            // street_suffix = '',
            // unit_number = '',
            street_number = '',
            street_number_1 = '',
            street_number_2 = '',
            lowercase_street_name = '',
            street_array = [],
            street_last_word = '';

        if (typeof place.address_components !== 'undefined') {
            // Get each component of the address from the place details
            // and fill the corresponding field on the form.

            for (var i = 0; i < place.address_components.length; i++) {
                var addressType = place.address_components[i].types[0];
                if (componentForm[addressType]) {
                    var val = place.address_components[i][componentForm[addressType]];
                    fetched_address[addressType] = val;
                }
            }

            // Split Street Number to Unit Number & Street Number
            if (typeof fetched_address.street_number !== 'undefined') {
                street_number = fetched_address.street_number;

                // append FULL ADDRESS
                combined_address = fetched_address.street_number;
            }

            // Check Street Number if it has '-'
            if (street_number !== '') {
                if (street_number.indexOf('-') > -1) {
                    var street_number_res = street_number.split('-');
                    street_number_1 = street_number_res[0];
                    street_number_2 = street_number_res[1];
                } else {
                    street_number_1 = street_number;
                }
            }

            // Check for suffix in street_name
            if (typeof fetched_address.route !== 'undefined') {
                lowercase_street_name = fetched_address.route.toLowerCase();
                street_array = lowercase_street_name.split(' ');
                street_last_word = street_array[street_array.length - 1];

                // append FULL ADDRESS
                if (combined_address.length) {
                    combined_address += ' ';
                }
                combined_address += fetched_address.route;
            }

            // new data
            newData['address'] = combined_address;
            newData['street_type'] = street_last_word;
            newData['unit_number'] = fetched_address.subpremise;
            newData['street_number'] = street_number_1;
            newData['street_number_2'] = street_number_2;
            newData['street_name'] = fetched_address.route;
            newData['suburb'] = fetched_address.locality;
            newData['postcode'] = fetched_address.postal_code;
            newData['state'] = fetched_address.administrative_area_level_1;
            newData['country'] = fetched_address.country;
        } else {
            console.log('no address data');
        }

        return newData;
    };

    /**
     * Request address data after user selects an address
     *
     * @param data
     * @returns {Promise<[geocodeResult] | void>}
     */
    onAddressSelect = async (data) => {
        const { onAddressFetched } = this.props;
        const address = data.description;

        return await geocodeByAddress(address)
            .then(results => {
                if(results[0] === undefined) {
                    return false;
                }

                const addressData = this.processAddressData(results[0]);
                console.log(addressData);
                onAddressFetched(addressData);
            })
            .catch(error => console.error(error));
    };

    generateProps() {
        const parentProps = super.generateProps();

        let props = {
            ...parentProps,
            inputClassName: 'field__input',
            autocompletionRequest: this.getAutocompletionRequest(),
            onSelect: this.onAddressSelect,
            loader: (
                <ReactLoading
                    className='button__spinner'
                    type='spin'
                    color='black'
                    height={20}
                    width={20}
                />
            )
        };

        return props;
    }

    render() {
        return(
            <React.Fragment>
                <label
                    className={this.handleClasses()}
                    data-label={super.renderAnimatedLabel()}
                    ref={(r) => (this.field = r)}
                >
                    {super.renderTooltip()}
                    {super.renderLabel()}
                    {super.renderAutoresize()}
                    <GooglePlacesAutocomplete
                        ref={(r) => (this.input = r)}
                        {...this.generateProps()}
                    />
                    {super.renderError()}
                    {super.renderLoading()}
                </label>
            </React.Fragment>
        );
    }
}

export default FieldAddress;
